import React, { useState } from "react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");

  const login = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
  `${process.env.REACT_APP_BACKEND_URL}/api/admin/login`,
  {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  }
);


      const data = await res.json();

      if (!data.ok) {
        alert("❌ Contraseña incorrecta");
        return;
      }

      // 🔥 Guardar token en localStorage
      localStorage.setItem("adminToken", data.token);

      alert("💼 Login de administrador correcto");

      // 🚀 Redirigir al panel
      window.location.href = "/admin-reviews";
    } catch (err) {
      console.error(err);
      alert("❌ Error de servidor");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        background: "#F8E3DD",
      }}
    >
      <form
        onSubmit={login}
        style={{
          padding: "30px",
          background: "white",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ marginBottom: "15px", textAlign: "center" }}>🔐 Admin</h2>

        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            background: "#E57373",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Entrar
        </button>
      </form>
    </div>
  );
}
